import { LevelsMetadataService } from '@openeducation/oe-rn-services';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';

export function useGetLevelsMetadata() {
  const { environment } = useEnvironmentContext();

  const { data, isLoading, error } = useQuery(['levels-metadata'], () =>
    LevelsMetadataService.getLevelsMetadata(environment)
  );

  return { data, isLoading, error };
}
